import axios from "axios"
import { isZipFile } from "./FileDropzone"

export const langMissmatch = (expectedLanguage?: string, detectedLanguages?: DetectedLanguage[]) => {
  if (!expectedLanguage) return false
  if (!detectedLanguages) return false
  const [detectedLanguage] = detectedLanguages.filter((dl) => dl.lang == expectedLanguage)
  return !detectedLanguage
}

export interface UploadedJobFile {
  id: string
  name: string
  size: number
  typedValidationError?: TypedValidationError
  detectedLanguages?: DetectedLanguage[]
}

export interface TypedValidationError {
  type: "WRONG_FILE_FORMAT" | "EMPTY_FILE"
  description: string
  message: string
}

export interface DetectedLanguage {
  lang: string
  prob: number
}

export async function uploadJobInputFile(file: File) {
  const form = new FormData()
  form.append("file", file)

  const response = await axios.post<UploadedJobFile>(`/api/wfl/v2/job-expiring-files`, form)
  return response.data
}

export async function uploadJobInputZipFile(file: File) {
  const form = new FormData()
  form.append("file", file)

  const response = await axios.post<UploadedJobFile[]>(`/api/wfl/v2/job-expiring-files/unzip`, form)
  return response.data
}


export const uploadFiles = (file: File) => {
  return isZipFile(file) ? uploadJobInputZipFile(file) : uploadJobInputFile(file)
}

export async function deleteFile(fileId: string) {
  await axios.delete(`/api/wfl/workflow/expiring-files/${fileId}`)
}

export interface UploadedFile {
  id: string
  name: string
  size: number
}

export async function uploadFile(file: File) {
  const form = new FormData()
  form.append("file", file)

  const response = await axios.post<UploadedFile>(`/api/wfl/workflow/expiring-files`, form)
  return response.data
}
